import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { APIEndpoints } from "../../config/apiEndpoint.config";
import { HttpService } from "../shared/http.service";
import { UnlockUserDto } from "../shared/Models/write/UnlockUserDto";
import { User } from "./models/user";
import { UserViewModel } from "./models/user.viewmodel";
import { ValidateUserResponse } from "./models/validateUserResponse";

@Injectable({
  providedIn: "root",
})
export class UserService {
  headers: HttpHeaders;
  user: User;

  constructor(private httpService: HttpService, private router: Router) {
    this.headers = new HttpHeaders();
    this.headers.set("Content-Type", "application/json");
  }

  userAuthentication(
    userViewModel: UserViewModel
  ): Observable<ValidateUserResponse> {
    return this.httpService.post(APIEndpoints.authenticateUrl, userViewModel);
  }

  logout() {
    this.router.navigateByUrl("/login");
  }

  getAllUsers(): Observable<Array<User>> {
    return this.httpService.get(APIEndpoints.getAllUsersUrl);
  }

  getAllUsersByRole(role: string): Observable<Array<User>> {
    return this.httpService.get(APIEndpoints.getUsersByRole + role);
  }

  createUser(user: UserViewModel): Observable<any> {
    return this.httpService.post(APIEndpoints.addUserUrl, user, true);
  }

  deleteUser(user: UserViewModel): Observable<any> {
    return this.httpService.post(APIEndpoints.deleteUserUrl, user, true);
  }

  updateUser(user: UserViewModel): Observable<any> {
    return this.httpService.post(APIEndpoints.updateUserUrl, user, true);
  }

  getUserRoles(): Observable<any> {
    return this.httpService.get(APIEndpoints.getAllRoles);
  }

  unlockUser(data: UnlockUserDto) {
    return this.httpService.post(APIEndpoints.unlockUser, data, true);
  }
}
